import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { withApollo, useQuery } from 'react-apollo';
import axios from 'axios';
import ReactSVG from 'react-svg';
import { toast } from 'react-toastify';
import { decode } from 'html-decoder';
import { disableBodyScroll } from 'body-scroll-lock';
import ReactGA from 'react-ga';
import { format } from 'date-fns';
import heart_path from 'heart_path.svg';
import sliderArrow from 'slider-arrow.svg';
import Pill from './Pill';
import Ratings from './Ratings';
import FavoriteSuccessBanner from './CustomToast/FavoriteSuccessBanner';
import { userQuery, communityQuery } from '../constants/queries';
import { handleHeartAnimation } from '../utils/handleHeartAnimation';
import { queryDateFormat } from '../constants/formats.json';
import { clientNoVarnish } from './client';

function RentalCard({
  property,
  is_small,
  id,
  setHoveredItem,
  checkIn,
  checkOut,
  guests,
  remote,
}) {
  const propertyImage =
    property.image_url || property.feature_image_url || property.images[0].url;

  // Initialize ReactGA on page load
  useEffect(() => {
    ReactGA.initialize('UA-134642264-1');
  }, []);

  const { data: userData } = useQuery(userQuery, {
    fetchPolicy: 'no-cache',
    client: clientNoVarnish,
  });
  const heartRef = useRef(null);
  const cardRef = useRef(null);
  // const [images, setImages] = useState([]);
  // const [goToNextImage, toggleGoToNextImage] = useState(false);

  const [favorited, setFavorited] = useState(false);
  useEffect(() => {
    if (property.favorited) {
      setFavorited(true);
    }
  }, [property.favorited]);

  const [favoriteRoute, setFavoriteRoute] = useState(null);
  useEffect(() => {
    setFavoriteRoute(window.Routes.toggle_favorite_property_path(property));
  }, [property]);

  // Make request for property
  // const loadDetails = async () => {
  //   if (client) {
  //     // If RentalCard is in CardSlider, connect with apollo and use graphql to make request for property
  //     const res = await client.query({
  //       query: propertyQuery,
  //       variables: { id: parseInt(property.id) },
  //     });

  //     setImages(res.data.property.images);
  //   } else {
  //     const tokenElement = document.querySelector('[name=csrf-token]');
  //     // If RentalCard is rendered in erb, fetch new property with axios
  //     const { data } = await axios.post(
  //       '/graphql',
  //       {
  //         operationName: 'PROPERTY_QUERY',
  //         query: propertyQueryString,
  //         variables: { id: parseInt(property.id) },
  //       },
  //       {
  //         headers: {
  //           'X-CSRF-Token': tokenElement ? tokenElement.content : '',
  //         },
  //       }
  //     );
  //     // data.data is intended
  //     setImages(data.data.property.images);
  //   }
  //   // This will move the slider to the next image if a user clicks the arrow before the images are loaded
  //   if (goToNextImage) {
  //     document
  //       .querySelector(`#${cardRef.current.id} .rental-slider-arrow.slick-next`)
  //       .click();
  //     toggleGoToNextImage(false);
  //   }
  // };

  const handleFavorited = () => {
    const tokenElement = document.querySelector('[name=csrf-token]');
    if (userData && userData.user && userData.user.id) {
      handleHeartAnimation({ ref: heartRef, isFavorited: favorited });
      axios
        .patch(favoriteRoute, null, {
          headers: {
            'X-CSRF-Token': tokenElement ? tokenElement.content : '',
            Accept: 'application/json',
          },
        })
        .then(res => {
          const { pathname } = window.location;
          if (res.status === 200) {
            if (
              pathname.includes('/account') ||
              pathname.includes('/favorites')
            ) {
              cardRef.current.style.opacity = 0;
              setTimeout(() => {
                cardRef.current.parentElement.remove();
              }, 300);
            }
            toast.dismiss();
            if (!favorited)
              toast(<FavoriteSuccessBanner favorited type={property} />);
            else toast(<FavoriteSuccessBanner type={property} />);
            setFavorited(!favorited);
          }
        })
        .catch(err => {
          console.error(err);
          if (err.response.status === 401) {
            window.location.pathname = window.Routes.login_path();
          }
        });
    } else {
      const modal = document.querySelector('#popup-modal');
      modal.classList.remove('fadeOut');
      modal.classList.remove('hidden');
      modal.classList.add('fadeIn');
      disableBodyScroll(modal);
    }
  };

  // const settings = {
  //   dots: !!images.length,
  //   infinite: false,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   dotsClass: 'custom-slick-dots',
  //   prevArrow: <RentalArrow />,
  //   nextArrow: (
  //     <RentalArrow
  //       disabled={images.length === 0}
  //       callback={() => toggleGoToNextImage(images.length === 0)}
  //     />
  //   ),
  //   swipe: false,
  //   touchMove: true,
  // };

  // Get community info
  const { data: communityData, error: commError } = useQuery(communityQuery, {
    variables: { id: property.comm_id },
  });

  if (commError) console.error(commError);

  const checkInQueryString = `?check_in=${format(checkIn, queryDateFormat)}`;
  const checkOutQueryString = `${checkIn ? '&' : '?'}check_out=${format(
    checkOut,
    queryDateFormat
  )}`;
  const guestsQueryString = `${
    checkIn || checkOut ? '&' : '?'
  }guests=${guests}`;
  const propertyURL = `${property.property_url}${
    checkIn ? checkInQueryString : ''
  }${checkOut ? checkOutQueryString : ''}${guests ? guestsQueryString : ''}`;

  let pillText = '';
  if (property.property_score === 100) pillText = 'Premier';
  if (property.ivol_url) pillText = 'Book Online';

  // if (!compressedImage) return <LoadingCard />;

  return (
    <div
      id={id}
      ref={cardRef}
      className={`rental-card ${is_small ? 'is_small' : ''}`}
      onMouseOver={() => {
        if (setHoveredItem) setHoveredItem(property);
        // loadDetails();
      }}
      onMouseLeave={() => {
        if (setHoveredItem) setHoveredItem(null);
      }}
      onFocus={() => {
        if (setHoveredItem) setHoveredItem(property);
        // loadDetails();
      }}
      onBlur={() => {
        if (setHoveredItem) setHoveredItem(null);
      }}
    >
      <section className="rental-upper-wrapper">
        <section className="pill--container listing__pill--container">
          {pillText && <Pill isRedPill={!!property.ivol_url}>{pillText}</Pill>}
        </section>
        <button
          aria-label="Toggle Favorite"
          name="Toggle Favorite"
          ref={heartRef}
          type="button"
          className={`card-heart rental-favorite ${
            property.favorited ? 'favorited' : ''
          }`}
          onClick={handleFavorited}
        >
          <ReactSVG src={heart_path} className="heart-icon" />
        </button>
        <a
          className="rental-card-slider-container"
          aria-label={`${decode(property.name)} Show Page`}
          href={propertyURL}
          target={remote ? '_blank' : ''}
          onClick={() => {
            if (window.location.pathname === '/search') {
              ReactGA.event({
                category: 'Property',
                action: 'Viewed Property from Search',
              });
            }
          }}
        >
          <section className="rental-image-outer">
            <img
              data-src={propertyImage}
              alt={`${property.name} - 1`}
              title={`${property.name} - 1`}
              className="rental-image lazyload"
            />
            <div className="rental-slider-overlay" />
          </section>
          {/* <Slider {...settings}>
            <section className="rental-image-outer">
              <img
                data-src={property.image_url}
                alt={`${property.name} - 1`}
                title={`${property.name} - 1`}
                className="rental-image lazyload"
              />
              <div className="rental-slider-overlay" />
            </section>
            {images.length ? (
              images.slice(1).map((image, ind) => (
                <section key={ind} className="rental-image-outer">
                  <img
                    data-src={image.url}
                    alt={image.caption || `${property.name} - ${ind}`}
                    title={image.caption || `${property.name} - ${ind}`}
                    className="rental-image lazyload"
                  />
                  <div className="rental-slider-overlay" />
                </section>
              ))
            ) : (
              <div className="loading-image-outer">
                <div />
              </div>
            )}
          </Slider> */}
        </a>
      </section>
      <a
        aria-label={`${decode(property.name)} Show Page`}
        className="rental-lower-wrapper"
        href={propertyURL}
        target={remote ? '_blank' : ''}
        onClick={() => {
          if (window.location.pathname === '/search') {
            ReactGA.event({
              category: 'Property',
              action: 'Viewed Property from Search',
            });
          }
        }}
      >
        <div className="rental-lower-header">
          <p className="rental-type">{property.property_type}</p>
          <Ratings
            rating={property.rating}
            rating_count={property.total_reviews}
          />
        </div>
        <h3 className="rental-title">{decode(property.name)}</h3>
        <p>{communityData && decode(communityData.community.name)}</p>
        <p>
          {property.nightly_rate
            ? `Starting from $${property.nightly_rate}/night`
            : 'Inquire for Rates'}
        </p>
        <p>
          {property.beds}br | {property.baths}ba | Sleeps {property.sleeps}
        </p>
      </a>
    </div>
  );
}

export default withApollo(RentalCard);
// export default RentalCard;

RentalCard.propTypes = {
  property: PropTypes.object.isRequired,
  is_small: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setHoveredItem: PropTypes.func,
  checkIn: PropTypes.string,
  checkOut: PropTypes.string,
  guests: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  remote: PropTypes.bool,
};
